import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { User, UserService } from '../../services/user.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, RouterModule, MaterialModule],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  currentUser!: User;
  isLoaded = false;

  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.userService.getCurrentUser().subscribe(res => {
      this.currentUser = this.userService.parseData(res);

      // isAdmin = true なら管理者画面に
      if (this.currentUser.isAdmin) {
        //this.router.navigate(['/admin/'])
      }

      this.isLoaded = true;
    });
  }

  goAdmin() {
    this.router.navigate(['/admin/'])
  }
}
